'use client';
import styled from 'styled-components';

export const SubtitleHeading = styled.p`
  text-align: center;
  max-width: 688px;
  margin: ${props => props.theme.spacing(2)} auto 0;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
  padding: ${props => props.theme.spacing(1, 0)};
`;

export const Subtext = styled.p`
  text-align: center;
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.primary};
`;

export const ButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 10px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    background-color: #e8e4d7;
    border: none;
  }
  @media ${props => props.theme.laptop} {
    top: 10px;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const AddOnForm = styled.form`
  margin-bottom: ${props => props.theme.spacing(11)};
`;

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${props => props.theme.spacing(4)} auto;

  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(6)} auto;
  }
`;

export const ExtrasSelectionContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(20)};
`;
